module.exports = __webpack_public_path__ + "static/media/moviexdb-netlify-app.49e0780f.jpg";